import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: { persistent: "", width: "300" },
      model: {
        value: _vm.visibilidade,
        callback: function ($$v) {
          _vm.visibilidade = $$v
        },
        expression: "visibilidade",
      },
    },
    [
      _c(
        VCard,
        { attrs: { color: _vm.cor, dark: "" } },
        [
          _c(
            VCardText,
            [
              _c(
                VRow,
                { staticClass: "justify-center" },
                [
                  _c("div", { staticClass: "mt-2" }, [
                    _vm._v(" " + _vm._s(_vm.texto) + " "),
                  ]),
                  _c(VProgressLinear, {
                    staticClass: "mb-0",
                    attrs: { indeterminate: "", color: _vm.corTexto },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }